import styled from "styled-components";
import {Phone} from "lucide-react";
import {AllCaps} from "./AllCaps";

export default function Header() {
    return (
        <Wrapper>
            <LogoSection>
                <LogoImage src="/images/b5.png" alt="Logo"/>
                <CompanyName>DaFa RheinSieg GmbH</CompanyName>
            </LogoSection>
            <AllCaps>
            <ContactSection>
                <section className="contactinfos">
                    <p>Vorgebirgsblick 30 | 53844 Troisdorf</p>
                </section>
                <section className="contactinfos">
                    <p>Rufen Sie uns an</p>
                    <PhoneRow as="a" href="tel:+4922419052702" >
                        <Phone className="phoneicon" size={14}/>
                        <span>+49 (0) 2241-905 27 02</span>
                    </PhoneRow>
                </section>
            </ContactSection>
            </AllCaps>
        </Wrapper>
    );
}



const Wrapper = styled.header`
    --logo-w: clamp(80px, 12vw, 120px);

    background-color: #f9fafb;
    display: grid;
    grid-template-columns: var(--logo-w) 1fr;
    align-items: start;
    gap: 3rem;
    padding: 1rem 2rem;
    min-height: 120px;     /* statt fixer Höhe */
    position: relative;
    z-index: 0;

    @media (max-width: 1024px) {
        padding: 0.75rem 1.25rem;
        gap: 1rem;
    }

    @media (max-width: 768px) {
        /* auf Mobile etwas luftiger und kein Höhen-Zwang */
        min-height: auto;
        padding: 0.75rem 1rem;
        grid-template-columns: var(--logo-w) 1fr;
    }

    @media (max-width: 420px) {
        /* sehr schmale Geräte: alles untereinander */
        grid-template-columns: 1fr;
        justify-items: center;
        text-align: center;
    }
`;

export const LogoSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: var(--logo-w);

    @media (max-width: 420px) {
        margin-bottom: 0.25rem;
    }
`;

export const ContactSection = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 1.25rem;
    padding-right: 0;             /* keine harte Einrückung */
    color: #344e97;

    .contactinfos {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;               /* für sauberes Umbrechen */
    }
    

    .phoneicon {
        color: #344e97;
        flex-shrink: 0;
    }

    @media (max-width: 1024px) {
        gap: 1rem;
    }

    @media (max-width: 768px) {
        /* auf Mobile: untereinander statt zu quetschen */
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    @media (max-width: 420px) {
        /* sehr klein: Adresse optional einkürzen/umbruch erlauben */
        align-items: center;
        padding-bottom: 20px;
        .contactinfos p {
            word-break: break-word;
        }
    }
`;

const PhoneRow = styled.section`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffda2a;
  font-weight: bolder;
  text-decoration: none;

  &.phone a, & { text-decoration: none;  color: #ffda2a;  /; }
`;


export const LogoImage = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
    transform: scaleX(-1);
`;

export const CompanyName = styled.p`
    color: #344e97;
    font-weight: bold;
    text-align: center;
    margin-top: 0.5rem;
    font-size: clamp(0.78rem, 1.5vw, 0.9rem);
`;
